<iframe
  title="casino" [src]="url"
  id="embedded_game" name="embedded_game"
  style="width: 100%; height: 100vh; position: absolute"></iframe>
